(function () {
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll("button[data-gallery-zoom-open]"));
    const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));
    const indexNode = gallery.querySelector("[data-gallery-index]");
    if (!slides.length) return;

    const show = (index) => {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== safeIndex; });
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.setAttribute("aria-current", thumbIndex === safeIndex ? "true" : "false");
      });
      if (indexNode) indexNode.textContent = String(safeIndex + 1);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => show(Number(thumb.dataset.galleryThumb || 0)));
    });

    const lightbox = gallery.closest("[data-product-page]")?.querySelector("[data-gallery-lightbox]");
    const lightboxImage = lightbox?.querySelector("[data-gallery-lightbox-image]");
    const closeButton = lightbox?.querySelector("[data-gallery-zoom-close]");
    slides.forEach((slide) => slide.addEventListener("click", () => {
      const image = slide.querySelector("img");
      if (!image || !lightbox || !lightboxImage) return;
      lightboxImage.src = image.currentSrc || image.src;
      lightboxImage.alt = image.alt;
      if (typeof lightbox.showModal === "function") lightbox.showModal();
    }));
    closeButton?.addEventListener("click", () => lightbox?.close());
    lightbox?.addEventListener("click", (event) => { if (event.target === lightbox) lightbox.close(); });

    show(0);
  });

  if (!reducedMotion && "IntersectionObserver" in window && document.querySelector("[data-product-page]")) {
    try {
      const revealSelector = "[data-product-image-reveal], [data-product-text-reveal]";
      const reveals = [...document.querySelectorAll(revealSelector)];
      reveals.forEach((item) => item.setAttribute("data-reveal-pending", "true"));
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute("data-reveal-visible", "true");
          entry.target.removeAttribute("data-reveal-pending");
          observer.unobserve(entry.target);
        });
      }, { rootMargin: "-50px 0px", threshold: 0 });
      reveals.forEach((item) => revealObserver.observe(item));
      document.documentElement.classList.add("has-product-image-reveal");
    } catch (error) {
      document.documentElement.classList.remove("has-product-image-reveal");
      document.querySelectorAll("[data-reveal-pending]").forEach((item) => item.removeAttribute("data-reveal-pending"));
    }
  }

  document.querySelectorAll("[data-shopify-variant-picker]").forEach((picker) => {
    const form = picker.closest("[data-product-buybox]")?.querySelector("form.product-form");
    const variantId = form?.querySelector('input[name="id"]');
    const price = picker.closest("[data-product-buybox]")?.querySelector("[data-product-current-price]");
    const availability = picker.closest("[data-product-buybox]")?.querySelector("[data-product-current-availability]");
    const addButton = form?.querySelector('button[name="add"]');
    if (!form || !variantId || !price || !addButton) return;

    picker.querySelectorAll("[data-shopify-variant]").forEach((option) => {
      option.addEventListener("click", () => {
        picker.querySelectorAll("[data-shopify-variant]").forEach((button) => button.setAttribute("aria-pressed", button === option ? "true" : "false"));
        variantId.value = option.dataset.variantId;
        if (price.dataset.priceStyle !== "from") price.textContent = option.dataset.variantPrice;
        const available = option.dataset.variantAvailable === "true";
        if (availability) {
                    const inventoryTracked = Boolean(option.dataset.variantInventoryManagement);
                              const stockQuantity = Number(option.dataset.variantStockQuantity);
                                        let stockLabel = available ? "Available" : "Sold out";
                                                  if (available && option.dataset.variantMadeToOrder === "true") {
              stockLabel = "Made to order";
            } else if (available && option.dataset.variantOneOfAKind === "true") {
              stockLabel = "Available · one of a kind";
            } else if (!available && option.dataset.variantOneOfAKind === "true") {
              stockLabel = "Sold";
            }
                                                                                                              availability.textContent = stockLabel;
                                                                                                                      }

        addButton.disabled = !available;
        addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
        const paymentButton = form.querySelector(".shopify-payment-button");
        if (paymentButton) paymentButton.hidden = !available;
      });
    });
  });

  document.querySelectorAll("[data-home-carousel]").forEach((carousel) => {
    const track = carousel.querySelector("[data-carousel-track]");
    if (!track) return;
    const scroll = (direction) => {
      const distance = Math.max(track.clientWidth * 0.82, track.querySelector("[data-carousel-item]")?.getBoundingClientRect().width || 0);
      track.scrollBy({ left: distance * direction, behavior: reducedMotion ? "auto" : "smooth" });
    };
    carousel.querySelector("[data-carousel-prev]")?.addEventListener("click", () => scroll(-1));
    carousel.querySelector("[data-carousel-next]")?.addEventListener("click", () => scroll(1));
  });

  if (!reducedMotion && "IntersectionObserver" in window && Element.prototype.animate) {
    const listSelector = "[data-product-list-apparition]";
    const cardSelector = ".home-product-card";
    const observedLists = new WeakSet();
    const playedCards = new WeakSet();
    let listObserver;

    const easeOut = (progress) => {
      const xFor = (t) => 3 * (1 - t) * t * t * 0.58 + t ** 3;
      const yFor = (t) => 3 * (1 - t) * t * t + t ** 3;
      let low = 0;
      let high = 1;
      for (let attempt = 0; attempt < 18; attempt += 1) {
        const middle = (low + high) / 2;
        if (xFor(middle) < progress) low = middle;
        else high = middle;
      }
      return yFor((low + high) / 2);
    };

    const getStaggerDelays = (count) => Array.from({ length: count }, (_, index) => {
      const progress = count < 2 ? 0 : index / (count - 1);
      return easeOut(progress) * 50;
    });

    const animateList = (list) => {
      listObserver.unobserve(list);
      const cards = [...list.querySelectorAll(cardSelector)];
      const delays = getStaggerDelays(cards.length);
      cards.forEach((card, index) => {
        if (playedCards.has(card)) return;
        playedCards.add(card);
        try {
          card.animate(
            [
              { opacity: 0, transform: "translateY(15px)" },
              { opacity: 1, transform: "translateY(0)" },
            ],
            { duration: 350, easing: "ease", delay: delays[index], fill: "both" },
          );
        } catch (error) {
          card.removeAttribute("data-product-apparition-pending");
        }
      });
    };

    const collectLists = (root) => {
      const lists = [...(root.querySelectorAll?.(listSelector) || [])];
      if (root.matches?.(listSelector)) lists.unshift(root);
      return lists;
    };

    const observeLists = (root = document) => {
      collectLists(root).forEach((list) => {
        if (observedLists.has(list)) return;
        const cards = [...list.querySelectorAll(cardSelector)];
        if (!cards.length) return;
        observedLists.add(list);
        cards.forEach((card) => card.setAttribute("data-product-apparition-pending", "true"));
        listObserver.observe(list);
      });
    };

    try {
      listObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) animateList(entry.target);
        });
      }, { rootMargin: "-50px 0px", threshold: 0 });
      observeLists();
      document.documentElement.classList.add("has-product-card-apparition");

      document.addEventListener("shopify:section:load", (event) => {
        try {
          observeLists(event.target);
          document.documentElement.classList.add("has-product-card-apparition");
        } catch (error) {
          event.target.querySelectorAll?.(`${listSelector} ${cardSelector}`).forEach((card) => card.removeAttribute("data-product-apparition-pending"));
        }
      });
    } catch (error) {
      document.documentElement.classList.remove("has-product-card-apparition");
      document.querySelectorAll(`${listSelector} ${cardSelector}`).forEach((card) => card.removeAttribute("data-product-apparition-pending"));
    }
  }

  document.querySelectorAll("[data-process-carousel]").forEach((carousel) => {
    const panels = Array.from(carousel.querySelectorAll("[data-process-panel]"));
    const tabs = Array.from(carousel.querySelectorAll("[data-process-step]"));
    if (!panels.length || !tabs.length) return;
    let activeIndex = 0;

    const show = (index) => {
      activeIndex = (index + panels.length) % panels.length;
      panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== activeIndex;
      });
      tabs.forEach((tab, tabIndex) => {
        tab.setAttribute("aria-selected", tabIndex === activeIndex ? "true" : "false");
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => show(Number(tab.dataset.processStep)));
    });
    carousel.querySelector("[data-process-prev]")?.addEventListener("click", () => show(activeIndex - 1));
    carousel.querySelector("[data-process-next]")?.addEventListener("click", () => show(activeIndex + 1));
    show(0);
  });

  document.querySelectorAll("[data-mobile-menu]").forEach((menu) => {
    menu.addEventListener("keydown", (event) => {
      if (event.key === "Escape") menu.open = false;
    });
    document.addEventListener("click", (event) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
  });

  if (!reducedMotion && "IntersectionObserver" in window) {
    const splitSelector = "[data-split-heading]";
    const lineClass = "split-heading__line";
    const innerClass = "split-heading__inner";
    const animated = new WeakSet();
    let observer;
    let setupComplete = false;
    let transitionsReady = false;

    const getOriginalText = (heading) => {
      const text = heading.querySelector(`.${lineClass}`)
        ? heading.dataset.splitHeadingOriginal || heading.getAttribute("aria-label") || heading.textContent
        : heading.textContent;
      return text.trim().replace(/\s+/g, " ");
    };

    const splitIntoVisualLines = (heading) => {
      const text = getOriginalText(heading);
      if (!text) return;
      heading.dataset.splitHeadingOriginal = text;
      heading.setAttribute("aria-label", text);

      const words = text.split(" ");
      const measureFragment = document.createDocumentFragment();
      const measureWords = words.map((word, index) => {
        const span = document.createElement("span");
        span.className = "split-heading__measure-word";
        span.textContent = word;
        measureFragment.append(span);
        if (index < words.length - 1) measureFragment.append(document.createTextNode(" "));
        return span;
      });
      heading.replaceChildren(measureFragment);

      const lines = [];
      measureWords.forEach((word, index) => {
        const top = word.getBoundingClientRect().top;
        let line = lines.find((candidate) => Math.abs(candidate.top - top) < 1.5);
        if (!line) {
          line = { top, words: [] };
          lines.push(line);
        }
        line.words.push(words[index]);
      });

      const finalFragment = document.createDocumentFragment();
      lines.forEach((line, index) => {
        const lineWrapper = document.createElement("span");
        lineWrapper.className = lineClass;
        lineWrapper.setAttribute("aria-hidden", "true");
        lineWrapper.dataset.splitLine = String(index);
        const inner = document.createElement("span");
        inner.className = innerClass;
        inner.style.setProperty("--split-line-index", String(index));
        inner.textContent = line.words.join(" ");
        lineWrapper.append(inner);
        finalFragment.append(lineWrapper);
      });
      heading.replaceChildren(finalFragment);
    };

    const collectHeadings = (root) => {
      const headings = [...(root.querySelectorAll?.(splitSelector) || [])];
      if (root.matches?.(splitSelector)) headings.unshift(root);
      return headings;
    };

    const setupHeadings = (root = document) => {
      collectHeadings(root).forEach((heading) => {
        splitIntoVisualLines(heading);
      });
    };

    const markScrollHeadings = (root = document) => {
      collectHeadings(root).forEach((heading) => {
        if (!heading.matches('[data-split-trigger="load"]') && !animated.has(heading)) animated.add(heading);
      });
    };

    const initialize = () => {
      if (setupComplete) return;
      try {
        observer = new IntersectionObserver((entries, activeObserver) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.setAttribute("data-split-heading-visible", "true");
              activeObserver.unobserve(entry.target);
            }
          });
        }, { rootMargin: "0px 0px -100px 0px", threshold: 0 });

        setupHeadings();
        document.documentElement.classList.add("has-split-heading-animation");
        document.documentElement.classList.add("is-split-heading-preparing");
        void document.documentElement.offsetWidth;
        setupComplete = true;

        const loadHeadings = collectHeadings(document).filter((heading) => heading.matches('[data-split-trigger="load"]'));
        markScrollHeadings();
        requestAnimationFrame(() => {
          document.documentElement.classList.remove("is-split-heading-preparing");
          loadHeadings.forEach((heading) => { void heading.offsetWidth; });
          requestAnimationFrame(() => {
            transitionsReady = true;
            loadHeadings.forEach((heading) => heading.setAttribute("data-split-heading-visible", "true"));
            collectHeadings(document).filter((heading) => !heading.matches('[data-split-trigger="load"]')).forEach((heading) => observer.observe(heading));
          });
        });

        document.addEventListener("shopify:section:load", (event) => {
          const section = event.target;
          const initializeSection = () => {
            try {
              setupHeadings(section);
              collectHeadings(section).filter((heading) => !heading.matches('[data-split-trigger="load"]')).forEach((heading) => {
                if (!animated.has(heading)) { animated.add(heading); if (transitionsReady) observer.observe(heading); }
              });
            } catch (error) { document.documentElement.classList.remove("has-split-heading-animation"); }
          };
          document.fonts?.ready ? document.fonts.ready.then(initializeSection) : initializeSection();
        });

        let resizeFrame = 0;
        const reflow = () => {
          cancelAnimationFrame(resizeFrame);
          resizeFrame = requestAnimationFrame(() => setupHeadings());
        };
        window.addEventListener("resize", reflow, { passive: true });
        document.fonts?.addEventListener?.("loadingdone", reflow);
      } catch (error) {
        document.documentElement.classList.remove("has-split-heading-animation");
        document.documentElement.classList.remove("is-split-heading-preparing");
        collectHeadings(document).forEach((heading) => {
          const text = getOriginalText(heading);
          heading.replaceChildren(document.createTextNode(text));
          heading.removeAttribute("aria-label");
        });
      }
    };

    const fontsReady = document.fonts?.ready || Promise.resolve();
    fontsReady.then(initialize).catch(() => initialize());
  }
})();


(() => {
  const addCountryFlags = (root = document) => {
    root.querySelectorAll("select#HeaderCountry, select#MobileCountry, select#FooterCountry").forEach((select) => {
      Array.from(select.options).forEach((option) => {
        const code = (option.value || "").toUpperCase();
        if (!/^[A-Z]{2}$/.test(code) || option.dataset.lunaFlagAdded) return;
        const flag = String.fromCodePoint(...Array.from(code, (letter) => 127397 + letter.charCodeAt(0)));
        option.textContent = `${flag} ${option.textContent.trim()}`;
        option.dataset.lunaFlagAdded = "true";
      });
    });
  };
  addCountryFlags();
  document.addEventListener("shopify:section:load", (event) => addCountryFlags(event.target));
})();
